import styled from 'styled-components'
import { typoHeading2 } from '../../../lib/styles/Typography'

export const Styled = {
  Group: styled.div`
    scroll-margin-top: 6rem;

    &:not(:last-child):after {
      background-color: ${p => p.theme.colors.black[6]};
      content: '';
      display: block;
      height: 1px;
      margin-top: 3rem;
      width: 100%;
    }
  `,
  GroupInner: styled.div`
    align-items: flex-start;
    display: flex;
    gap: 4rem;

    @media screen and (max-width: 768px) {
      gap: 1rem;
    }
  `,
  GroupLeft: styled.div<{
    menuOpen?: boolean
  }>`
    flex: 0 0 auto;
    position: sticky;
    top: 5rem;
    z-index: ${p => (p.menuOpen ? '10' : '0')};

    @media screen and (min-width: 1401px) {
      top: 6rem;
    }
  `,
  GroupLetterButtonContainer: styled.div``,
  GroupLetter: styled.div`
    ${typoHeading2}
  `,
  GroupRight: styled.div`
    flex: 1 1 auto;
    padding-top: 0.5rem;
    overflow: hidden;
  `,
  ItemContent: styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
  `,
}
